export default "__VITE_ASSET__CbzdIty6__"